export function formatPaymentMethodDisplay(order) {
  const method = String(order?.paymentMethod || '').trim();
  const type = String(order?.paymentType || '').trim();
  if (method === 'Online Payment') return type || 'Online Payment';
  if (method === 'COD' || type === 'COD' || /cash on delivery/i.test(method)) return 'COD';
  return method || '—';
}

export function formatPaymentStatusDisplay(status) {
  if (status === 'Pending (Cash on Delivery)') return 'Pending (COD)';
  return status || '—';
}

export const PAYMENT_METHODS = ['All', 'COD', 'Online Payment'];
export const PAYMENT_TYPES = ['All', 'COD', 'NayaPay', 'JazzCash'];
export const PAYMENT_STATUSES = [
  'All',
  'Pending (Cash on Delivery)',
  'Pending Verification',
  'Verified',
  'Rejected',
];

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '03039936931';
export const WHATSAPP_NUMBER_INTL = `92${WHATSAPP_NUMBER.replace(/^0/, '')}`;

export function isOnlinePayment(order) {
  return (
    order?.paymentMethod === 'Online Payment' ||
    order?.paymentType === 'NayaPay' ||
    order?.paymentType === 'JazzCash'
  );
}

export function canConfirmOrder(order) {
  if (isOnlinePayment(order)) {
    return order.paymentStatus === 'Verified' && order.status === 'Pending';
  }
  return order.status === 'Pending';
}

export function canDispatchOrder(order) {
  if (isOnlinePayment(order) && order.paymentStatus !== 'Verified') {
    return false;
  }
  return order.status === 'Confirmed';
}

export function needsPaymentVerification(order) {
  return isOnlinePayment(order) && order.paymentStatus === 'Pending Verification';
}

export function filterOrdersByPayment(orders, { paymentMethod, paymentType, paymentStatus }) {
  let result = [...orders];
  if (paymentMethod && paymentMethod !== 'All') {
    result = result.filter((o) => o.paymentMethod === paymentMethod);
  }
  if (paymentType && paymentType !== 'All') {
    result = result.filter((o) => o.paymentType === paymentType);
  }
  if (paymentStatus && paymentStatus !== 'All') {
    result = result.filter((o) => o.paymentStatus === paymentStatus);
  }
  return result;
}

export function openAdminWhatsApp(order) {
  const url = `https://wa.me/${WHATSAPP_NUMBER_INTL}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function paymentExportFields(order) {
  return {
    'Payment Method': order.paymentMethod || '—',
    'Payment Type': order.paymentType || '—',
    'Payment Status': order.paymentStatus || '—',
  };
}
